import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FieldDataChangedEvent } from "devextreme/ui/form";
import {
  WysiwygEditorComponent,
  WysiwygEngine
} from "src/app/components/ui/wysiwyg-editor/wysiwyg-editor.component";

//const TEXTAREA_MAX_LENGTH = 1024;

@Component({
  selector: "snt-report-form-renderer-textarea",
  templateUrl: "report-form-renderer-textarea.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererTextareaComponent {
  @ViewChild(WysiwygEditorComponent)
  sntWysiwygEditorComponent: WysiwygEditorComponent | undefined;

  @Input()
  item!: any;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  @Output()
  value: EventEmitter<string> = new EventEmitter();

  //readonly textMaxLength = TEXTAREA_MAX_LENGTH;

  formData = {
    value: ""
  };

  get currentTextLength(): number {
    return this.formData.value?.length ?? 0;
  }

  protected readonly WysiwygEngine = WysiwygEngine;

  ngOnInit(): void {
    this.formData.value = this.item.text || this.item.value || "";
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "textarea",
      config: {
        title: this.item.config.title,
        value: this.formData.value
      }
    };
  }

  onFieldDataChanged({ value, dataField }: FieldDataChangedEvent): void {}

  onContentChanged(): void {
    let value = this.sntWysiwygEditorComponent?.getContent() || "";
    /*if (value.length > TEXTAREA_MAX_LENGTH) {
      value = value.slice(0, TEXTAREA_MAX_LENGTH);
      this.formData.value = value;
      this.sntWysiwygEditorComponent?.setContent(value);
    }*/

    this.item.value = value;
    this.formData.value = value;
    this.value.emit(value);
  }
}
